import React, { Fragment, useEffect, useState, useImperativeHandle, forwardRef, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export default forwardRef(function ReCaptcha({
    setCaptchaValue,
    sitekey,
    lang,
    onValidated,
    outerClass,
    wrapperClass,
    onExpired = () => {},
}, ref) {
    const recaptchaRef = useRef(null);  
    const [ load, setLoad ] = useState(false);
    const [ expired, setExpired ] = useState(true);
    const [ value, setValue ] = useState('');
    const [ errorValue, setErrorValue ] = useState('');

    useEffect(() => {
        setTimeout(() => {
            setLoad(true);
        }, 100);
    },[]);

    useImperativeHandle(ref, () => ({
        reset() {
            recaptchaRef.current?.reset();
            setCaptchaValue?.(null);
            setExpired(true);
            setValue('');
        },
    }));

    const handleChange = value => {
        if (value && typeof onValidated === 'function') {
            onValidated();
            setExpired(false);
        }
        setValue(value);
        setCaptchaValue(value);
        if (value === null) { setExpired(true); }
    };

    const handleCaptchaExpired = () => {
        onExpired();
        setCaptchaValue(null);
        setExpired(true);                         
    };

    const handleError = value => {
        setErrorValue(value);
    };
    // const asyncScriptOnLoad = () => {
    //     console.log("scriptLoad - reCaptcha Ref-", _recaptchaRef);
    // };

    if (value && expired && errorValue) {
        const testValues = () => <Fragment> {value} {expired} </Fragment>;
        console.log(testValues);
    }

    return (
        <div className='grid-row'>
            <div className={`g-recaptcha ${outerClass}`}>
                <div className={`recaptcha-wrapper ${wrapperClass}`}  data-size='compact'>
                    {load &&
                        <ReCAPTCHA
                            ref={ recaptchaRef }              
                            sitekey={sitekey}
                            hl={lang}
                            onChange={ handleChange }
                            onErrored={ handleError }
                            onExpired={handleCaptchaExpired}
                            //asyncScriptOnLoad={asyncScriptOnLoad}
                        />
                    }
                </div>
            </div>
        </div>
    );
});